(() => {
  function init(root = document) {
    root.querySelectorAll('[data-sa-promotion]').forEach(card => {
      if (card.dataset.initialized) return;
      card.dataset.initialized = 'true';
      const video = card.querySelector('video');
      const play = card.querySelector('[data-promotion-play]');
      play.addEventListener('click', async () => {
        if (!video.src) { video.src = video.dataset.src; video.load(); }
        video.controls = true;
        try { await video.play(); play.hidden = true; }
        catch { play.hidden = false; }
      });
      video.addEventListener('play', () => {
        document.querySelectorAll('[data-sa-promotion] video').forEach(other => {
          if (other !== video) other.pause();
        });
        play.hidden = true;
      });
      video.addEventListener('ended', () => { play.hidden = false; });
      video.addEventListener('error', () => {
        play.hidden = false;
        card.querySelector('[data-promotion-fallback]').hidden = false;
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(entries => {
          if (entries[0].intersectionRatio < .1) video.pause();
        }, { threshold: .1 }).observe(video);
      }
    });
    root.querySelectorAll('[data-promotion-carousel]').forEach(carousel => {
      if (carousel.dataset.initialized) return;
      carousel.dataset.initialized = 'true';
      const rail = carousel.querySelector('[data-promotion-rail]');
      const prev = carousel.querySelector('[data-promotion-prev]');
      const next = carousel.querySelector('[data-promotion-next]');
      const update = () => {
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
      };
      function move(direction) {
        const step = rail.firstElementChild.getBoundingClientRect().width + 24;
        rail.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      rail.addEventListener('keydown', event => {
        if (event.target !== rail) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      rail.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(rail); update();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) document.querySelectorAll('[data-sa-promotion] video').forEach(video => video.pause());
  });
})();
